import {
  ComponentMap,
  SimpleMarkdown,
  isResourceName,
} from '@spotify/confidence-core-react';
import { getTypeOrNull } from '@spotify/confidence-graphql';
import { cleanLegacyBody } from '@spotify/plugin-confidence-activity-react';
import { MentionChip } from '@spotify/plugin-confidence-comments-react';
import {
  ISSUE_ACTIVITY_TYPES,
  IssueActivityTypeOptions,
  TASK_ACTIVITY_TYPES,
  createIssueActivityTypeExtension,
} from '@spotify/plugin-confidence-issues-react';

const MARKDOWN_COMPONENTS: Partial<ComponentMap> = {
  resource: ({ resourceRef, children }) => {
    if (resourceRef && isResourceName(resourceRef, 'identities')) {
      return <MentionChip displayName={children} name={resourceRef} />;
    }

    return <strong data-resource={resourceRef}>{children}</strong>;
  },
};

const ActivityTypeMarkdownBody = ({ activity }: IssueActivityTypeOptions) => {
  if (!activity.body) {
    return null;
  }

  return (
    <SimpleMarkdown
      variant="body2"
      color="textSecondary"
      content={cleanLegacyBody(
        activity.body,
        getTypeOrNull(activity.actor)?.name,
        getTypeOrNull(activity.actor)?.displayName,
        activity.primaryResource,
      )}
      components={MARKDOWN_COMPONENTS}
    />
  );
};

const createMarkdownActivityTypeExtension = (id: string) =>
  createIssueActivityTypeExtension({
    id,
    render: ActivityTypeMarkdownBody,
  });

export const ISSUE_CREATED_ACTIVITY_TYPE_EXTENSION =
  createIssueActivityTypeExtension({
    id: ISSUE_ACTIVITY_TYPES.created,
    render: () => null,
  });

export const ISSUE_STATE_CHANGED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(ISSUE_ACTIVITY_TYPES.stateChanged);

export const ISSUE_ASSIGNMENT_CHANGED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(ISSUE_ACTIVITY_TYPES.assignmentChanged);

export const ISSUE_UPDATED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(ISSUE_ACTIVITY_TYPES.updated);

export const ISSUE_DELETED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(ISSUE_ACTIVITY_TYPES.deleted);

export const TASK_CREATED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(TASK_ACTIVITY_TYPES.created);

export const TASK_STATE_CHANGED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(TASK_ACTIVITY_TYPES.stateChanged);

export const TASK_INPUT_REQUESTED_ACTIVITY_TYPE_EXTENSION =
  createIssueActivityTypeExtension({
    id: TASK_ACTIVITY_TYPES.inputRequested,
    render: ActivityTypeMarkdownBody,
  });

export const TASK_UPDATED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(TASK_ACTIVITY_TYPES.updated);

export const TASK_DELETED_ACTIVITY_TYPE_EXTENSION =
  createMarkdownActivityTypeExtension(TASK_ACTIVITY_TYPES.deleted);
